var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('populate-form',{ref:"operateForm",attrs:{"formTitle":"預約紀錄操作","fkey":"ro01","populateOptionVar":"operateOptions","formDataObjVar":"operateData"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }